import { render, staticRenderFns } from "./AccountingManagement.vue?vue&type=template&id=12979c4d&"
import script from "./AccountingManagement.vue?vue&type=script&lang=js&"
export * from "./AccountingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports